import { createAxiosClient } from "@ntg/component-library/utilities";
import { useMutation } from "@tanstack/react-query";

const apiClient = createAxiosClient("D365FO");

interface IRollbackReleasedProductsFromManufacturingPayload {
    designID: number;
    includeD365Cleanup: boolean;
    mItemID: number;
}

async function rollbackReleasedProductsFromManufacturing(
    payload: IRollbackReleasedProductsFromManufacturingPayload,
): Promise<string> {
    const response = await apiClient.post<string>(
        "/FunctionAppsStarter/RollbackReleasedProductsFromManufacturing",
        payload,
    );
    return response.data;
}

export function useRollbackReleasedProductsFromManufacturing() {
    return useMutation({
        mutationFn: rollbackReleasedProductsFromManufacturing,
    });
}
